import { jsPDF } from 'jspdf';

export interface EmargementInput {
  sessionRef: string;
  formationTitre: string;
  jour: string; // ISO YYYY-MM-DD
  formateurNom: string;
  lieu: string;
  participants: { nom: string; present: boolean }[];
  entrepriseNom?: string;
}

/** Génère et télécharge un PDF d'émargement A4 portrait. */
export function generateEmargementPDF(input: EmargementInput): void {
  const doc = new jsPDF({ format: 'a4', unit: 'mm', orientation: 'portrait' });
  const margin = 15;
  let y = margin;

  // Header
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(input.entrepriseNom ?? 'KOST Academy', margin, y);
  y += 6;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text("Feuille d'émargement", margin, y);
  y += 8;

  // Infos session
  doc.setDrawColor(180);
  doc.line(margin, y, 210 - margin, y);
  y += 5;
  doc.setFontSize(9);
  doc.text(`Session : ${input.sessionRef}`, margin, y);
  doc.text(`Date : ${formatJourFr(input.jour)}`, 110, y);
  y += 5;
  doc.text(`Formation : ${input.formationTitre}`, margin, y);
  y += 5;
  doc.text(`Formateur : ${input.formateurNom}`, margin, y);
  doc.text(`Lieu : ${input.lieu}`, 110, y);
  y += 8;

  // Tableau
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setFillColor(230, 230, 230);
  doc.rect(margin, y, 180, 7, 'F');
  doc.text('#', margin + 2, y + 5);
  doc.text('Participant', margin + 10, y + 5);
  doc.text('Matin', margin + 90, y + 5);
  doc.text('Après-midi', margin + 115, y + 5);
  doc.text('Signature', margin + 145, y + 5);
  y += 7;
  doc.setFont('helvetica', 'normal');

  input.participants.forEach((p, i) => {
    doc.line(margin, y, margin + 180, y);
    y += 8;
    doc.text(String(i + 1), margin + 2, y - 2);
    doc.text(p.nom, margin + 10, y - 2);
    if (p.present) {
      doc.setTextColor(0, 128, 0);
      doc.text('✓', margin + 95, y - 2);
      doc.text('✓', margin + 122, y - 2);
      doc.setTextColor(0);
    }
  });
  doc.line(margin, y, margin + 180, y);

  // Footer formateur
  y += 15;
  doc.setFontSize(9);
  doc.text('Signature formateur :', margin, y);
  doc.line(margin + 40, y + 1, margin + 100, y + 1);
  y += 12;
  doc.setFontSize(7);
  doc.setTextColor(120);
  doc.text(
    'Document généré automatiquement par KOST ERP — ' + new Date().toLocaleString('fr-FR'),
    margin,
    285,
  );

  doc.save(`emargement_${input.sessionRef}_${input.jour}.pdf`);
}

function formatJourFr(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
